import { APP_CONFIG } from '@/utils/env';
import { LogoSigns, LogoWrapper, TooltipWrapper } from './style';
import { AGENT_SPECIAL_LIST } from '@/interfaces';

function Logo() {
  const title = AGENT_SPECIAL_LIST.includes(APP_CONFIG.agentSpecial || "") ? "Bellagio" : "APIM";
  return (
    <TooltipWrapper title={title} arrow>
      <LogoWrapper to="/">
        <LogoSigns>
          <img 
          width='100%' 
          height='100%' 
          src={AGENT_SPECIAL_LIST.includes(APP_CONFIG.agentSpecial || "") ? '/static/images/mix-logo-bellagio.svg' : '/static/images/mix-logo.svg'} 
          alt='mix-logo' 
          />
        </LogoSigns>
      </LogoWrapper>
    </TooltipWrapper>
  );
}

export default Logo;
